const notificationsListTranslationsEN = {
  notificationsListTitle: 'Notifications',
  notificationsList: 'Notifications',
};

export default notificationsListTranslationsEN;
